import React, { useState } from "react";
import { Form, Input } from "antd";
import SellerReplyInputField from "./SellerReplyInputField";
import Button from "../Button";
import { LoadingOutlined } from "@ant-design/icons";
import { transformData } from "../../../utils/helper/sellerReply";
import { useParams } from "react-router-dom";
import { sendSellerReply } from "../../../utils/API/sellerReply";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { transactionReply } from "../../../utils/API/transactionReply";

const SellerReply = ({
  documents,
  messageId,
  setChat,
  onComplete,
  actionRequired = false,
  transactionId,
}) => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  // console.log("Transaction ID", transactionId);
  // console.log("Message ID", messageId)
  const submitHandler = async (data) => {
    try {
      // console.log("Remarks", data.remarks);
      if (actionRequired === true) {
        setLoading(true);
        const fdata = transformData(data, documents);
        
        const formData = {
          transaction_id: transactionId,
          messageId,
          answer: {
            remarks: data.remarks,
            document_list: fdata,
          },
        };
        const response = await transactionReply(formData, dispatch);

        setChat(response);
        onComplete(false);
      } else {
        setLoading(true);
        const fdata = transformData(data, documents);
        const final_data = {
          projectId: id,
          messageId,
          answer: {
            remarks: data.remarks,
            document_list: fdata,
          },
        };
        const response = await sendSellerReply(final_data, dispatch);
        setChat(response);
        onComplete(false);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form
      form={form}
      onFinish={submitHandler}
      noValidate
      className="offset-form font-spaceGrotesk"
    >
      <Form.Item
        className="font-normal mt-8"
        name="remarks"
        rules={[
          {
            required: true,
            message: "Write a message",
          },
        ]}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
      >
        <div className="text-area">
          <Input.TextArea
            showCount
            placeholder="Write a Message"
            className="border-2 focus-within:shadow-none rounded-lg font-spaceGrotesk"
            style={{ height: 60, resize: "none", width: "40rem" }}
          />
        </div>
      </Form.Item>

      {documents.map(({ doc_name, doc_file, text_required }, index) => (
        <SellerReplyInputField
          form={form}
          key={`field_${index}`}
          docname={doc_name}
          needUpload={doc_file}
          needText={text_required}
          index={index + 1}
        />
      ))}

      <Button
        type="submit"
        color="blue-300"
        varient="primary"
        className="w-fit flex items-center gap-x-1 font-semibold py-2 px-8 mt-4 text-xs bg-blue-300 text-blue-800"
      >
        Send
        {!loading ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={13}
            height={10}
            viewBox="0 0 15 12"
            fill="none"
          >
            <path
              d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75L1 5.25ZM14.5303 6.53033C14.8232 6.23744 14.8232 5.76256 14.5303 5.46967L9.75736 0.696698C9.46447 0.403805 8.98959 0.403805 8.6967 0.696698C8.40381 0.989592 8.40381 1.46447 8.6967 1.75736L12.9393 6L8.6967 10.2426C8.40381 10.5355 8.40381 11.0104 8.6967 11.3033C8.98959 11.5962 9.46447 11.5962 9.75736 11.3033L14.5303 6.53033ZM1 6.75L14 6.75L14 5.25L1 5.25L1 6.75Z"
              fill="#4361EE"
            />
          </svg>
        ) : (
          <LoadingOutlined />
        )}
      </Button>
    </Form>
  );
};

export default SellerReply;
